import { createFileRoute } from "@tanstack/react-router"
import { WhatsappAccountAlerts } from "modules/settings/components/integrations/whatsapp/WhatsappAccountAlerts"

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/alerts")({
  component: WhatsappAccountAlerts,
})
